import { axiosClient } from "./axiosClient"

export const PRODUCTION_RECORD_PATH = '/api/v1/production-record'

export const addProductionRecord = (body) => {
    return axiosClient.post(PRODUCTION_RECORD_PATH, body)
}

export const updateProductionRecord = (id, body) => {
    return axiosClient.put(`${PRODUCTION_RECORD_PATH}/${id}`, body)
}

export const deleteProductionRecord = (id) => {
    return axiosClient.delete(`${PRODUCTION_RECORD_PATH}/${id}`)
}

export const getProductionRecordById = (id) => {
    return axiosClient.get(`${PRODUCTION_RECORD_PATH}/${id}`)
}

export const getPageProductionRecords = ({ lastId = '', id = "", outsourcerId = '', productId = "", boilerCode = "", status = "", invoiceNumberOut = "" }) => {
    return axiosClient.get(`${PRODUCTION_RECORD_PATH}/page?lastId=${lastId}&id=${id}&outsourcerId=${outsourcerId}&productId=${productId}&boilerCode=${boilerCode}&status=${status}&invoiceNumberOut=${invoiceNumberOut}`)
}

export const chargeProductionRecord = (id) => {
    return axiosClient.put(`${PRODUCTION_RECORD_PATH}/charge/${id}`)
}

export const deChargeProductionRecord = (id) => {
    return axiosClient.put(`${PRODUCTION_RECORD_PATH}/de-charge/${id}`)
}

export const downloadProductionRecordReceipt = (id) => {
    return axiosClient.get(`${PRODUCTION_RECORD_PATH}/download-receipt/${id}`, {
        responseType: 'arraybuffer',
    })
}

export const uploadProductionRecordExcelFile = (body) => {
    return axiosClient.post(`${PRODUCTION_RECORD_PATH}/upload-excel`, body)
}